import { Box } from 'braid-design-system';

import * as styles from './TextFieldBox.css';

interface Props {
  isFocused: boolean;
  isInvalid: boolean;
  addPadding?: boolean;
  children: React.ReactNode;
}

const TextFieldBox: React.FC<Props> = ({
  isFocused,
  isInvalid,
  addPadding = false,
  children,
}) => {
  const getClass = () => {
    if (isFocused) {
      return styles.focus;
    } else if (isInvalid) {
      return styles.invalid;
    }
    return styles.base;
  };
  return (
    <Box className={[getClass(), addPadding ? styles.padding : '']}>
      {children}
    </Box>
  );
};

export default TextFieldBox;
